import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconZap"><Path d="M13.9984 0.550293L2.22266 15.9219H9.99844V23.4658L21.7659 8.00002H13.9984V0.550293Z" fill="currentColor"/></CentralIconBase>;
});

export default IconZap;
